import axios from 'axios'

// API 基礎路徑：統一使用相對路徑，由 Vite proxy 轉發到後端
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || ''

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,  // 支援 cookies 跨域傳送
})

// 請求攔截器
api.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 響應攔截器
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 未授權錯誤是正常的,不需要在控制台顯示
    if (error.response?.status !== 401) {
      console.error('API Error:', error.response?.data || error.message)
    }
    return Promise.reject(error)
  }
)

export const dashboardApi = {
  getStats: () => api.get('/dashboard/stats'),
  getRevenueTrend: (days = 30) => api.get(`/dashboard/revenue-trend?days=${days}`),
  getBalanceAlerts: () => api.get('/dashboard/balance-alerts'),
  getTopCustomers: (limit = 10) => api.get(`/dashboard/top-customers?limit=${limit}`),
  getRecentTransactions: (limit = 10) => api.get(`/dashboard/recent-transactions?limit=${limit}`),
}

export const customersApi = {
  getAll: (status) => api.get('/customers', { params: { status } }),
  getById: (id) => api.get(`/customers/${id}`),
  create: (data) => api.post('/customers', data),
  update: (id, data) => api.put(`/customers/${id}`, data),
  delete: (id) => api.delete(`/customers/${id}`),
  getBalance: (id) => api.get(`/customers/${id}/balance`),
  getEditors: (id) => api.get(`/customers/${id}/editors`),
  addEditor: (id, userId) => api.post(`/customers/${id}/editors`, { user_id: userId }),
  removeEditor: (id, userId) => api.delete(`/customers/${id}/editors/${userId}`),
}

export const azureCostsApi = {
  getCosts: (params) => api.get('/azure/costs', { params }),
  createCost: (data) => api.post('/azure/costs', data),
  getSummary: (params) => api.get('/azure/costs/summary', { params }),
  getTrend: (params) => api.get('/azure/costs/trend', { params }),
}

export const expenseApi = {
  getCustomerReports: (customerId) => api.get(`/expense/customer/${customerId}/reports`),
  deleteReport: (reportId) => api.delete(`/expense/${reportId}`),
  deleteCustomerReports: (customerId) => api.delete(`/expense/customer/${customerId}/reports`),
  getReport: (reportId) => api.get(`/expense/${reportId}`),
  getReportItems: (reportId) => api.get(`/expense/${reportId}/items`),
}

export const usersApi = {
  getAll: () => api.get('/users'),
  updateRole: (id, role) => api.put(`/users/${id}/role`, { role }),
  updateStatus: (id, is_active) => api.put(`/users/${id}/status`, { is_active }),
}

export const emailApi = {
  send: (data) => api.post('/email/send', data),
}

export const auditApi = {
  getLogs: (params) => api.get('/audit-logs', { params }),
  getFilters: () => api.get('/audit-logs/filters'),
}

/**
 * 統一處理 API 錯誤訊息
 * 403 錯誤會顯示「需要管理員權限」
 */
export const getErrorMessage = (error, defaultMsg = '操作失敗') => {
  if (error.response?.status === 403) {
    const msg = error.response?.data?.message || '';
    if (msg.includes('管理員')) {
      return '❌ 此操作需要管理員權限';
    }
    return '❌ 權限不足，無法執行此操作';
  }
  return error.response?.data?.error || error.response?.data?.message || error.response?.data?.detail || error.message || defaultMsg;
}

export default api
